module.exports = __webpack_public_path__ + "static/img/联想晨星足式机器人IS.ddb6a690.png";